<template>
  <div class="modal fade" ref="modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 shadow">
        <div class="modal-header border-0" :class="customerServiceId ? 'bg-warning' : 'bg-success text-white'">
          <h5 class="modal-title fw-bold">
            <i class="fas fa-ticket-alt me-2"></i>
            {{ customerServiceId ? `Editar Ticket #${customerServiceId}` : 'Novo Ticket' }}
          </h5>
          <button type="button" class="btn-close" :class="{ 'btn-close-white': !customerServiceId }" @click="closeModal" :disabled="saving"></button>
        </div>

        <div class="modal-body p-4">
          <form @submit.prevent="submit" id="ticket-form">
            <div class="row gy-5 gx-3">
              <div class="col-md-6">
                <label class="form-label d-block small fw-bold mb-2">Consultor <span class="text-danger">*</span></label>
                <v-select :reduce="i => i.id" placeholder="Selecione o consultor..." label="name"
                  v-model="form.user_id" :options="users" />
              </div>

              <div class="col-md-6">
                <label class="form-label d-block small fw-bold mb-2">Cliente <span class="text-danger">*</span></label>
                <v-select :reduce="i => i.id" placeholder="Selecione o cliente..." label="name"
                  v-model="form.customer_id" :options="customers" />
              </div>

              <div class="col-md-6">
                <label class="form-label d-block small fw-bold mb-2">Atividade <span class="text-danger">*</span></label>
                <v-select :reduce="i => i.id" placeholder="Selecione a atividade..." label="name"
                  v-model="form.task_id" :options="tasks" />
              </div>

              <div class="col-md-6">
                <label class="form-label d-block small fw-bold mb-2">Classificação <span class="text-danger">*</span></label>
                <v-select :reduce="i => i.id" placeholder="Selecione a classificação..." label="name"
                  v-model="form.task_type_id" :options="taskTypes" />
              </div>

              <div class="col-md-4">
                <label class="form-label d-block small fw-bold mb-2">Ticket Movidesk</label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0">#</span>
                  <input class="form-control border-start-0" type="number" v-model="form.movidesk_ticket_id"
                    placeholder="ID no Movidesk" />
                </div>
              </div>

              <div class="col-md-4" v-if="isFixedValue">
                <label class="form-label d-block small fw-bold mb-2">Valor Fixo <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text bg-light border-end-0">R$</span>
                  <input class="form-control border-start-0" type="number" step="0.01" v-model="form.fixed_value"
                    placeholder="0,00" />
                </div>
              </div>

              <div :class="isFixedValue ? 'col-md-4' : 'col-md-8'">
                <label class="form-label d-block small fw-bold mb-2">Observação <span class="text-danger">*</span></label>
                <textarea class="form-control" v-model="form.note" rows="3"
                  placeholder="Descreva o atendimento detalhadamente..." maxlength="2000"></textarea>
                <div class="d-flex justify-content-between mt-1">
                  <div class="form-text small ms-auto">{{ (form.note || '').length }}/2000</div>
                </div>
              </div>

              <div v-if="allErrors.length" class="col-12 mt-4">
                <div class="alert alert-danger border-0 shadow-sm rounded-4 py-3">
                  <div class="d-flex align-items-center mb-2">
                    <i class="fas fa-exclamation-circle me-2 text-danger"></i>
                    <span class="fw-bold small text-uppercase letter-spacing-1 text-danger">Por favor, corrija os erros abaixo:</span>
                  </div>
                  <ul class="mb-0 ps-4 small fw-bold text-danger">
                    <li v-for="(error, index) in allErrors" :key="index">
                      {{ error }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" @click="closeModal" :disabled="saving">Cancelar</button>
          <button type="submit" form="ticket-form" class="btn btn-primary-action" :class="customerServiceId ? 'btn-warning' : 'btn-success'" :disabled="saving">
            <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
            <i v-else :class="customerServiceId ? 'fas fa-save' : 'fas fa-check'" class="me-2"></i>
            {{ customerServiceId ? 'Atualizar Ticket' : 'Salvar Ticket' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import $ from 'jquery'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'TicketFormModal',
  components: { vSelect },
  props: {
    users: Array,
    customers: Array,
    tasks: Array,
    taskTypes: Array
  },
  data() {
    return {
      customerServiceId: null,
      saving: false,
      isFixedValue: false,
      form: {
        user_id: null,
        customer_id: null,
        task_id: null,
        task_type_id: null,
        note: '',
        fixed_value: null,
        movidesk_ticket_id: null
      },
      errors: {}
    }
  },
  computed: {
    allErrors() {
      return Object.values(this.errors).flat()
    }
  },
  methods: {
    open(ticket = null) {
      this.errors = {}
      if (ticket) {
        this.customerServiceId = ticket.id
        this.form = {
          user_id: ticket.user_id,
          customer_id: ticket.customer_id,
          task_id: ticket.task_id,
          task_type_id: ticket.task_type_id,
          note: ticket.note,
          fixed_value: ticket.fixed_value,
          movidesk_ticket_id: ticket.movidesk_ticket_id
        }
        this.isFixedValue = !!ticket.is_fixed_value
      } else {
        this.resetForm()
      }

      $(this.$refs.modal).modal('show')
    },
    resetForm() {
      this.customerServiceId = null
      this.isFixedValue = false
      this.form = {
        user_id: null,
        customer_id: null,
        task_id: null,
        task_type_id: null,
        note: '',
        fixed_value: null,
        movidesk_ticket_id: null
      }
    },
    closeModal() {
      $(this.$refs.modal).modal('hide')
    },
    async submit() {
      this.saving = true
      this.errors = {}
      
      const payload = {
        ...this.form,
        is_fixed_value: this.isFixedValue,
        fixed_value: this.isFixedValue ? this.form.fixed_value : null
      }

      try {
        if (this.customerServiceId) {
          await axios.put(`/api/customer-service/${this.customerServiceId}`, payload)
          this.$toast.success("Ticket atualizado com sucesso!")
        } else {
          await axios.post('/api/customer-service', payload)
          this.$toast.success("Ticket criado com sucesso!")
        }
        this.$emit('saved')
        this.closeModal()
      } catch (err) {
        if (err.response && err.response.data && err.response.data.errors) {
          this.errors = err.response.data.errors
        } else {
          this.$toast.error("Ocorreu um erro ao salvar o ticket.")
        }
      } finally {
        this.saving = false
      }
    }
  },
  watch: {
    'form.task_type_id'(val) {
      if (val && this.taskTypes) {
        const type = this.taskTypes.find(t => t.id === val)
        this.isFixedValue = type ? !!type.is_fixed_value : false
      } else {
        this.isFixedValue = false
      }
    }
  }
}
</script>

<style scoped lang="sass">
.modal-content
  border-radius: 20px
  overflow: hidden
  border: none
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25)

.modal-header
  padding: 24px 32px
  border: none
  
  &.bg-success
    background: linear-gradient(135deg, #00b894 0%, #00cec9 100%) !important
  
  &.bg-warning
    background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%) !important
    color: white

.modal-title
  font-weight: 800
  letter-spacing: -0.5px
  font-size: 1.4rem

.modal-body
  padding: 32px
  background-color: #fff

.form-label
  color: #2d3436
  font-weight: 700
  font-size: 0.82rem
  text-transform: uppercase
  letter-spacing: 1px
  margin-bottom: 12px

.v-select
  --vs-border-color: #dfe6e9
  --vs-border-radius: 12px
  --vs-font-size: 0.95rem
  --vs-line-height: 1.4
  transition: all 0.2s ease

  &:hover
    --vs-border-color: #b2bec3

  ::v-deep .vs__dropdown-toggle
    padding: 6px 12px
    border-width: 2px
    background: #fdfdfd

  ::v-deep .vs__search::placeholder
    color: #b2bec3

.form-control
  border-radius: 12px
  border: 2px solid #dfe6e9
  padding: 12px 16px
  font-size: 0.95rem
  background: #fdfdfd
  transition: all 0.2s ease

  &:focus
    border-color: #00b894
    box-shadow: 0 0 0 4px rgba(0, 184, 148, 0.1)
    background: #fff

.input-group
  .input-group-text
    border: 2px solid #dfe6e9
    border-right: none
    border-radius: 12px 0 0 12px
    background: #f1f2f6
    color: #636e72
    font-weight: 600

  .form-control
    border-radius: 0 12px 12px 0

.modal-footer
  padding: 24px 32px
  background-color: #f8f9fa
  border: none
  display: flex
  justify-content: flex-end
  gap: 12px

.btn-link
  color: #636e72
  font-weight: 600
  text-decoration: none
  padding: 10px 20px
  transition: all 0.2s

  &:hover
    color: #2d3436
    background: rgba(0,0,0,0.05)
    border-radius: 10px

.btn-primary-action
  padding: 12px 32px
  border-radius: 12px
  font-weight: 700
  border: none
  transition: all 0.3s ease
  box-shadow: 0 4px 15px rgba(0,0,0,0.1)

  &.btn-success
    background: linear-gradient(135deg, #00b894 0%, #00cec9 100%)
    color: white
    &:hover
      transform: translateY(-2px)
      box-shadow: 0 6px 20px rgba(0, 184, 148, 0.3)

  &.btn-warning
    background: linear-gradient(135deg, #fdcb6e 0%, #e17055 100%)
    color: white
    &:hover
      transform: translateY(-2px)
      box-shadow: 0 6px 20px rgba(225, 112, 85, 0.3)

.text-danger
  color: #ff7675 !important

.alert-danger
  background-color: rgba(255, 118, 117, 0.1)
  border-radius: 12px

.letter-spacing-1
  letter-spacing: 1px
</style>
